import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'zf-s3-upload',
  template: `
    <p>
      s3-upload works!
    </p>
  `,
  styles: [
  ]
})
export class S3UploadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
